/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PagingArgs
 */
export interface PagingArgs {
    /**
     * 
     * @type {number}
     * @memberof PagingArgs
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof PagingArgs
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof PagingArgs
     */
    skipAmount: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagingArgs
     */
    usePaging: boolean;
}

/**
 * Check if a given object implements the PagingArgs interface.
 */
export function instanceOfPagingArgs(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pageNumber" in value;
    isInstance = isInstance && "pageSize" in value;
    isInstance = isInstance && "skipAmount" in value;
    isInstance = isInstance && "usePaging" in value;

    return isInstance;
}

export function PagingArgsFromJSON(json: any): PagingArgs {
    return PagingArgsFromJSONTyped(json, false);
}

export function PagingArgsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagingArgs {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pageNumber': json['PageNumber'],
        'pageSize': json['PageSize'],
        'skipAmount': json['SkipAmount'],
        'usePaging': json['UsePaging'],
    };
}

export function PagingArgsToJSON(value?: PagingArgs | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PageNumber': value.pageNumber,
        'PageSize': value.pageSize,
        'SkipAmount': value.skipAmount,
        'UsePaging': value.usePaging,
    };
}

